import { Injectable } from '@angular/core';
import { Address } from '../interfaces/home';

@Injectable({
  providedIn: 'root',
})

export class AddressService {
  getFullAddress(address: Address): string {
    if (address.streetAddress && address.city && address.state) {
      return `${address.streetAddress}, ${address.city}, ${address.state}`;
    }
    return '';
  }

  isAddressComplete(address: Address): boolean {
    return !!(address.streetAddress && address.city && address.state && address.zipcode);
  }
}
